var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import StyledIcon from './StyledIcon';

var CloseIcon = function CloseIcon(props) {
  return React.createElement(
    StyledIcon,
    _extends({}, props, { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 12 12' }),
    React.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fillRule: 'evenodd' },
      React.createElement('path', { d: 'M7.41425,6.00025 L11.70725,1.70725 C12.09825,1.31625 12.09825,0.68425 11.70725,0.29325 C11.31625,-0.09775 10.68425,-0.09775 10.29325,0.29325 L6.00025,4.58625 L1.70725,0.29325 C1.31625,-0.09775 0.68425,-0.09775 0.29325,0.29325 C-0.09775,0.68425 -0.09775,1.31625 0.29325,1.70725 L4.58625,6.00025 L0.29325,10.29325 C-0.09775,10.68425 -0.09775,11.31625 0.29325,11.70725 C0.48825,11.90225 0.74425,12.00025 1.00025,12.00025 C1.25625,12.00025 1.51225,11.90225 1.70725,11.70725 L6.00025,7.41425 L10.29325,11.70725 C10.48825,11.90225 10.74425,12.00025 11.00025,12.00025 C11.25625,12.00025 11.51225,11.90225 11.70725,11.70725 C12.09825,11.31625 12.09825,10.68425 11.70725,10.29325 L7.41425,6.00025 Z' })
    )
  );
};
export default CloseIcon;